module.exports = __webpack_public_path__ + "static/media/payoneer.45ea1e0b.pdf";